export default __webpack_public_path__ + "img/13.d72b0f5a.jpg";